import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    guidedMode: true,
    showMenu: true,
    version: "10.15.2020",
    fullscreen: false

  },
  mutations: {
    guidedMode (state, value){
      state.guidedMode = value;
    },
    showMenu (state, value){
      state.showMenu = value;
    },
    fullscreen (state, value){
      state.fullscreen = value;
    },
  },
  actions: {
  },
  modules: {
  }
})
